import Rails from '@rails/ujs'
import Select from '../behaviours/Select'
import ToggleAlert from '../behaviours/ToggleAlert'
import ToggleCanvasMenu from '../behaviours/ToggleCanvasMenu'
import ToggleDropDownMenu from '../behaviours/ToggleDropDownMenu'
import GalleryUploader from '../behaviours/GalleryUploader'
import SingleImageUploader from '../behaviours/SingleImageUploader'
import ToggleTabs from '../behaviours/ToggleTabs'
import MapBox from '../behaviours/MapBox'
import DateTimePicker from '../behaviours/DateTimePicker'
import DatePicker from '../behaviours/DatePicker'
import AiPlaceDetailsGenerator from '../behaviours/AiPlaceDetailsGenerator'
import ImageGridContainer from '../behaviours/ImageGridContainer'
import AiPlaceSuggestionsGenerator from '../behaviours/AiPlaceSuggestionsGenerator'
import AiRegionSuggestionsGenerator from '../behaviours/AiRegionSuggestionsGenerator'
import CsvAttractionPreview from '../behaviours/CsvAttractionPreview'

Rails.start()
ToggleAlert()
ToggleCanvasMenu()
ToggleDropDownMenu()
Select()
GalleryUploader()
SingleImageUploader()
ToggleTabs()
MapBox()
DateTimePicker()
DatePicker()
AiPlaceDetailsGenerator()
ImageGridContainer()
AiPlaceSuggestionsGenerator()
AiRegionSuggestionsGenerator()
CsvAttractionPreview()

import "../stylesheets/admin.scss"
